import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { publishBatteryArbitrage } from "./battery-arbitrage-cache"
import type { BatteryArbitrageDto } from "../dto/battery-arbitrage.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

export default function useRetryBatteryProposalArbitrage(): UseMutationResult<
  BatteryArbitrageDto,
  unknown,
  { proposalId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId }) =>
      batteryProposalService.retryArbitrage(proposalId),
    onSuccess: (arbitrage, { proposalId }) =>
      publishBatteryArbitrage(queryClient, proposalId, arbitrage),
  })
}
